import { CmsRequestType } from './types';
import { fetchScopeFromCms } from './utils';
export function fetchTranslation(request) {
    return fetchScopeFromCms(request, CmsRequestType.TRANSLATION);
}
//# sourceMappingURL=translation.js.map